import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackEvent } from '../lib/customerEventTracker';

const SCROLL_SHOW_THRESHOLD = 400;

/**
 * Fixed "back to top" arrow — sits directly above the WhatsApp FAB on the
 * right edge, fades in once the user has scrolled past SCROLL_SHOW_THRESHOLD.
 */
const BackToTopButton = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_SHOW_THRESHOLD);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    trackEvent({
      event_name: 'cta_click',
      event_action: 'click',
      event_status: 'success',
      event_category: 'navigation',
      cta_name: 'back_to_top_fab',
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={t('backToTop.aria', 'Back to top')}
      tabIndex={visible ? 0 : -1}
      className={`fixed right-6 lg:right-7 bottom-[166px] lg:bottom-[94px] z-40 w-12 h-12 rounded-full bg-[#0f2540] hover:bg-[#14A098] flex items-center justify-center shadow-lg shadow-black/20 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <ArrowUp className="w-5 h-5 text-white" aria-hidden />
    </button>
  );
};

export default BackToTopButton;
